<template>
  <li
      @click="$emit('select', airport)" class="pl-6 py-2 flex overflow-y-hidden border-t border-grey-200"
      :class="(airport.is_open && (airport.jetfly_pc12_operability !== 'unoperable' || airport.jetfly_pc24_operability !== 'unoperable' || airport.jetfly_sf50_operability !== 'unoperable')) ? 'cursor-pointer hover:bg-grey-100' : 'cursor-not-allowed'"
  >
    <SvgJetSmall class="mt-1 h-4 w-4 flex-shrink-0"/>
    <div class="ml-3 truncate flex-1">
      <p class="font-medium truncate">{{ airport.name }}</p>
      <p class="text-xs flex items-center">
        <Flag :iso="airport.country.iso_code" class="h-3 mr-2"/>
        <span v-if="airport.served_city">{{ airport.served_city }}</span>
        <span v-if="airport.distance"> - {{ Math.round(airport.distance / 1000) }} km</span>
      </p>
      <ul class="mt-2 flex items-center flex-wrap">
        <li
            v-for="(tag, index) in airportTags" :key="tag.label + index"
            class="mr-4 py-px rounded-full text-xs font-medium whitespace-no-wrap flex items-center"
            :class="[`text-${tag.type}`]"
        >
          <div class="w-2 h-2 bg-current rounded-full mr-1.5"></div>
          <span>{{ tag.label }}</span>
        </li>
      </ul>
    </div>
  </li>
</template>

<script>
import Flag from '@/components/Flag'
import SvgJetSmall from '@/components/svg/JetSmall'

export default {
  components: {Flag, SvgJetSmall},
  props: {
    airport: {type: Object, required: true},
  },
  computed: {
    airportTags() {
      if (
          this.airport.jetfly_pc12_operability === 'operable'
          && this.airport.jetfly_pc24_operability === 'operable'
          && this.airport.jetfly_sf50_operability === 'operable'
      ) {
        return [
          {type: 'success', label: 'PC-12, PC-24 & SF50 Operable'},
        ]
      }

      if (
          this.airport.jetfly_pc12_operability === 'unoperable'
          && this.airport.jetfly_pc24_operability === 'unoperable'
          && this.airport.jetfly_sf50_operability === 'unoperable'
      ) {
        return [
          {type: 'danger', label: 'PC-12, PC-24 & SF50 Unoperable'},
        ]
      }

      if (
          this.airport.jetfly_pc12_operability === 'restricted'
          && this.airport.jetfly_pc24_operability === 'restricted'
          && this.airport.jetfly_sf50_operability === 'restricted'
      ) {
        return [
          {type: 'warning', label: 'PC-12, PC-24 & SF50 Restricted'},
        ]
      }

      let airportTags = [];

      if (this.airport.jetfly_pc12_operability === 'operable') {
        airportTags.push({type: 'success', label: 'PC-12 Operable'})
      }

      if (this.airport.jetfly_pc12_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'PC-12 Unoperable'})
      }

      if (this.airport.jetfly_pc12_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'PC-12 Restricted'})
      }

      if (this.airport.jetfly_pc24_operability === 'operable') {
        airportTags.push({type: 'success', label: 'PC-24 Operable'})
      }

      if (this.airport.jetfly_pc24_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'PC-24 Unoperable'})
      }

      if (this.airport.jetfly_pc24_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'PC-24 Restricted'})
      }

      if (this.airport.jetfly_sf50_operability === 'operable') {
        airportTags.push({type: 'success', label: 'SF50 Operable'})
      }

      if (this.airport.jetfly_sf50_operability === 'unoperable') {
        airportTags.push({type: 'danger', label: 'SF50 Unoperable'})
      }

      if (this.airport.jetfly_sf50_operability === 'restricted') {
        airportTags.push({type: 'warning', label: 'SF50 Restricted'})
      }

      return airportTags;
    }
  }
}
</script>